<template>
  <v-container fluid>
    <v-snackbar v-model="showSnackbar" :color="snackbar.color" transition="slide-y-reverse-transition">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showSnackbar = false"
        >
          {{getTranslated('_close')}}
        </v-btn>
      </template>
    </v-snackbar>

    <ConfirmationDialog
      :showDialog="showConfirmationDialog"
      :text="getTranslated('_LctRackTemplateWillDeleted')"
      @accept="deleteLctRackTemplate"
      @cancel="cancelDeleteDialog"
    ></ConfirmationDialog>

    <ConfirmationDialog
      :showDialog="showBayTemplateConfirmationDialog"
      :text="getTranslated('_LctRackBayTemplateWillDeleted')"
      @accept="deleteLctRackBayTemplate"
      @cancel="cancelDeleteDialog"
    ></ConfirmationDialog>

    <LctRackTemplateEditionDialog
      :openDialog="showEditionDialog"
      @input="showEditionDialog = false"
      @saved="notify"
      :translations="translations"
    ></LctRackTemplateEditionDialog>

    <LctRackBayTemplateEditionDialog
      :openDialog="showEditionDialog2"
      @input="showEditionDialog2 = false"
      @saved="rackBayTemplateSaved"
      :translations="translations"
      :rackTemplateId="rackTemplateId"
      :bayQuantity="bayQuantity"
      :lastOrdinal="lastOrdinal"
    ></LctRackBayTemplateEditionDialog>

    <v-skeleton-loader
      :loading="tableLoading"
      type="table"
      class="elevation-1 my-12"
      transition="fade-transition"
    >
      <v-data-table
        must-sort
        :headers="headers"
        :items="lct_racktemplateList"
        width="100%"
        show-expand
        single-expand
        :hide-default-footer="lct_racktemplateList.length <= 10"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{getTranslated('_LctRackTemplates')}}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" dark class="mb-2" icon x-large @click.stop="showEditionDialog=true" v-if="permits.writePermit">
              <v-icon>
                add_circle
              </v-icon>
            </v-btn>
          </v-toolbar>
        </template>

        <template #item.action="{ item }">
          <v-icon
            small
            class="mr-1"
            @click="editLct_RackTemplate(item)"
          >
            edit
          </v-icon>
          <span class="text-overline" style="cursor: pointer" @click="editLct_RackTemplate(item)">{{getTranslated('_edit')}}</span>
          <v-icon
            small
            class="mr-1 ml-4"
            @click="openDeleteDialog(item)"
          >
            delete
          </v-icon>
          <span class="text-overline" style="cursor: pointer" @click="openDeleteDialog(item)">{{getTranslated('_delete')}}</span>
        </template>

       <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" style="padding: 0">
            <v-data-table
              :items="item.bays"
              :headers="bayHeaders"
              must-sort
              class="elevation-1"
              hide-default-footer
              :items-per-page="-1"
              width="100%"
            >
              <template v-slot:top>
                <v-toolbar dense flat>
                  <v-toolbar-title class="red--text" v-if="item.racktemplatebayquantity > item.bays.length">{{getTranslated('_allBaysNeeded') + ' ' + item.bays.length + '/' + item.racktemplatebayquantity}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip left :disabled="item.racktemplatebayquantity > item.bays.length" transition="slide-x-reverse-transition" v-if="permits.writePermit">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-btn v-if="permits.writePermit" color="primary" class="mt-2" x-large icon style="padding: 0px" :disabled="item.racktemplatebayquantity <= item.bays.length" @click.stop="openRackBayEdtionDialog(item)">
                          <v-icon>
                            add_circle
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{getTranslated('_allBaysAdded')}}</span>
                  </v-tooltip>
                </v-toolbar>
              </template>

              <template #item.action="{ item }">
                <!--<v-icon
                  small
                  class="mr-1"
                  @click="editPosition(item)"
                >
                  edit
                </v-icon>
                <span class="text-overline" style="cursor: pointer" @click="editPosition(item)">{{getTranslated('_edit')}}</span>-->
                <v-icon
                  small
                  class="mr-1 ml-4"
                  @click="openRackBayTemplateDeleteDialog(item)"
                >
                  delete
                </v-icon>
                <span class="text-overline" style="cursor: pointer" @click="openRackBayTemplateDeleteDialog(item)">{{getTranslated('_delete')}}</span>
              </template>

              <template #no-data>
                <label>{{getTranslated('_LctRackBayTemplateNoData')}}</label>
              </template>

            </v-data-table>
          </td>
        </template>

        <template #no-data>
          <label>{{getTranslated('_LctRackTemplateNoData')}}</label>
        </template>

        <template #item.jpg="{ item }">
          <v-img :src="item.jpg ? item.jpg : ''" max-height="40" aspect-ratio="1" contain></v-img>
        </template>
      </v-data-table>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { actions } from '../store/types/lct_racktemplateTypes.js'
import lctracktemplatesService from '../services/Lct_RackTemplatesService.js'
import translationsService from '../services/TranslationsService'
import screenService from '../services/ScreenService.js'
import headerService from '../services/HeaderService.js'
const LctRackTemplateEditionDialog = () => import('../components/Lct_RackTemplateEditionDialog.vue')
const LctRackBayTemplateEditionDialog = () => import('../components/Lct_RackBayTemplateEditionDialog.vue')
const ConfirmationDialog = () => import('../components/ConfirmationDialog.vue')

export default {
  components: {
    LctRackTemplateEditionDialog,
    LctRackBayTemplateEditionDialog,
    ConfirmationDialog
  },
  data () {
    return {
      tableLoading: true,
      showSnackbar: false,
      snackbar: {
        color: '',
        message: ''
      },
      showConfirmationDialog: false,
      showBayTemplateConfirmationDialog: false,
      showEditionDialog: false,
      lct_racktemplateToDelete: '',
      translations: [
        { key: '_required', translation: 'Required' },
        { key: '_LctRackTemplateWillDeleted', translation: 'Lct_RackTemplate will be deleted' },
        { key: '_LctRackBayTemplateWillDeleted', translation: 'Lct_RackBayTemplate will be deleted' },
        { key: '_close', translation: 'Close' }
      ],
      permits: '',
      bayHeaders: [],
      bays: [],
      rackTemplateId: '',
      bayTemplateId: '',
      ordinal: '',
      headers: [],
      bayQuantity: 0,
      showEditionDialog2: false,
      lastOrdinal: 0
    }
  },
  computed: mapState({
    lct_racktemplateList: state => state.lctracktemplates.lct_racktemplateList
  }),
  methods: {
    ...mapActions({
      saveCurrentLct_RackTemplate: actions.SAVE_CURRENT_LCT_RACKTEMPLATE,
      getLct_RackTemplates: actions.GET_LCT_RACKTEMPLATES
    }),
    editLct_RackTemplate (item) {
      this.saveCurrentLct_RackTemplate(item)
      this.showEditionDialog = true
    },
    openDeleteDialog (item) {
      this.showConfirmationDialog = true
      this.lct_racktemplateToDelete = item.id
    },
    openRackBayTemplateDeleteDialog (item) {
      this.rackTemplateId = item.rackTemplateId
      this.bayTemplateId = item.bayTemplateId
      this.ordinal = item.bayTemplateOrdinal
      this.showBayTemplateConfirmationDialog = true
    },
    async deleteLctRackTemplate (item) {
      await lctracktemplatesService.deleteLct_RackTemplate(this.lct_racktemplateToDelete).then(res => {
        this.cancelDeleteDialog()
        this.getLct_RackTemplates()
        this.snackbar.color = res.request.status === 200 ? 'green' : 'red'
        this.snackbar.message = res.request.status === 200 ? this.getTranslated('_LctRackTemplateDeleted') : this.getTranslated('_LctRackTemplateDeletedError')
        this.showSnackbar = true
      }).catch((e) => this.errorManagement(e))
    },
    async deleteLctRackBayTemplate (item) {
      await lctracktemplatesService.deleteLct_RackBayTemplate(this.rackTemplateId, this.bayTemplateId, this.ordinal).then(res => {
        this.cancelDeleteDialog()
        this.getLct_RackTemplates()
        this.snackbar.color = res.request.status === 200 ? 'green' : 'red'
        this.snackbar.message = res.request.status === 200 ? this.getTranslated('_LctRackBayTemplateDeleted') : this.getTranslated('_LctRackBayTemplateDeletedError')
        this.showSnackbar = true
      }).catch((e) => this.errorManagement(e))
    },
    cancelDeleteDialog () {
      this.showConfirmationDialog = false
      this.showBayTemplateConfirmationDialog = false
      this.lct_racktemplateToDelete = ''
      this.rackTemplateId = ''
      this.bayTemplateId = ''
      this.ordinal = ''
      this.bayQuantity = 0
    },
    notify (notification) {
      this.snackbar.color = notification.color
      this.snackbar.message = notification.message
      this.showSnackbar = true
    },
    async loadLct_RackTemplates () {
      await this.getLct_RackTemplates().catch((e) => this.errorManagement(e))
      this.tableLoading = false
    },
    async initialize () {
      if (this.$root.$data.user.profile !== undefined) {
        this.permits = await screenService.getScreenPermits('Lct_RackTemplates', this.$root.$data.user.profile['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']).catch((e) => this.errorManagement(e))
        this.permits = this.permits.data
        await screenService.getScreenPermits('Lct_RackBayTemplates', this.$root.$data.user.profile['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']).catch((e) => this.errorManagement(e))
        await this.getTranslations().catch((e) => this.errorManagement(e))
        await this.getBayHeaders().catch((e) => this.errorManagement(e))
        await this.getHeaders().catch((e) => this.errorManagement(e))
        this.headers.forEach(element => {
          // Especificamos el tamaño del campo action
          if (element.value === 'action') {
            element.width = '320px'
          }
        })
      }
    },
    async getTranslations () {
      if (this.$root.$data.user.profile !== undefined) {
        await translationsService.get('Lct_RackTemplates', this.$root.$data.user.profile['customclaim-language']).then(res => {
          this.translations = res.data
        })
      }
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    async getBayHeaders () {
      this.bayHeaders = await headerService.getHeaders('Lct_RackBayTemplates')
      this.bayHeaders = this.bayHeaders.data
    },
    async getHeaders () {
      this.headers = await headerService.getHeaders('Lct_RackTemplates')
      this.headers = this.headers.data
    },
    openRackBayEdtionDialog (item) {
      this.lastOrdinal = this.getLastOrdinal(item)
      this.rackTemplateId = item.id
      this.bayQuantity = item.racktemplatebayquantity
      this.showEditionDialog2 = true
    },
    rackBayTemplateSaved (notification) {
      this.notify(notification)
      this.loadLct_RackTemplates()
    },
    getLastOrdinal (item) {
      if (item.bays.length > 0) {
        return Math.max.apply(Math, item.bays.map(function (o) { return o.bayTemplateOrdinal }))
      } else {
        return 0
      }
    },
    errorManagement (e) {
      if (e.response !== undefined) {
        switch (e.response.status) {
          case 401:
            this.notify({ color: 'warning', message: 'Unauthorized error' })
            break
          case 422:
            this.notify({ color: 'warning', message: 'Unprocessable Entity error' })
            break
          case 500:
            this.notify({ color: 'warning', message: 'Internal server error' })
            break
          default:
            this.notify({ color: 'warning', message: 'Unexpected error' })
            break
        }
      } else {
        this.notify({ color: 'warning', message: 'Unexpected error' })
      }
    }
  },
  async created () {
    await this.initialize()
    this.loadLct_RackTemplates()
  }
}
</script>
